import { ContextualField, PropertyType } from '../../../../models/';

export const targetProperty: ContextualField = {
    modelName: 'target',
    propertyType: PropertyType.Number,
    label: 'Target',
    placeholder: 'Target',
    propertyName: 'targetProperty',
    icon: 'fa-bullseye'
};